import { ReactNode } from 'react';
import { Flex } from '@coverflex-tech/hypernova';

export function PageLayout({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <Flex flexDirection="column" gap="xl" className={className}>
      {children}
    </Flex>
  );
}
